// @flow
import { shadow } from '../assets/scripts/constants';

const apiHost = process.env.REACT_APP_API_HOST || 'eclisse.muotolevy.fi';

const checkDataFreshness = async () => {
  const apiUrl = `https://${apiHost}/wp-json/eclisse/v1/last-modified`;
  const cachedDatetime = localStorage.getItem('lastModified');

  let data = await fetch(`${apiUrl}?${shadow}`, {
    method: 'GET',
    credentials: 'same-origin',
  });

  if (data.status && data.ok) {
    data = await data.json();

    if (data.toString() === cachedDatetime) {
      return true;
    }
    localStorage.setItem('lastModified', data);
    return false;
  }

  return true;
};

/**
 * Fetches the configurator options from WordPress.
 *
 * @returns {object} Config options with terms included.
 */
export default async function fetchOptions() {
  const devOptions = process.env.REACT_APP_DEV_OPTIONS;

  if (devOptions) {
    console.log('fetchOptions:', 'Currently using development data.');
    return JSON.parse(devOptions);
  }

  const apiUrl = `https://${apiHost}/wp-json/wc/v2/products/attributes`;
  const basicAuthHash = process.env.REACT_APP_BASIC_AUTH_HASH;

  if (!basicAuthHash) {
    throw new Error('fetchOptions: Missing basic auth hash.');
  }

  const freshData = await checkDataFreshness();
  const cachedConfigOptions = localStorage.getItem('configOptions');

  if (!!cachedConfigOptions && freshData) {
    return JSON.parse(cachedConfigOptions);
  }

  const headers = new Headers();
  headers.append('Authorization', `Basic ${basicAuthHash}`);

  // Fetch configurations
  let configurations = await fetch(`${apiUrl}?${shadow}`, {
    headers,
    method: 'GET',
    credentials: 'same-origin',
  });

  if (configurations.status && configurations.ok) {
    configurations = await configurations.json();

    let configurationTermsRaw = [];
    let configurationTerms = [];

    // Fetch terms
    configurations.forEach(config => {
      configurationTermsRaw.push(
        fetch(`${apiUrl}/${config.id}/terms?per_page=100&${shadow}`, {
          headers,
          method: 'GET',
          credentials: 'same-origin',
        })
      );
    });
    configurationTermsRaw = await Promise.all(configurationTermsRaw);

    configurationTermsRaw.forEach(term => {
      configurationTerms.push(term.json());
    });
    configurationTerms = await Promise.all(configurationTerms);

    // Merge terms into configurations
    for (let i = configurations.length - 1; i >= 0; i -= 1) {
      configurations[i].terms = configurationTerms[i];
    }

    configurations = configurations.reduce(
      (configs, config) => ({ ...configs, [config.slug]: config }),
      {}
    );
  } else {
    throw new Error('fetchOptions: Error loading configurations form server.');
  } // end configurations.status && configurations.ok

  // console.dir(JSON.stringify(configurations)); // create new mock data.

  localStorage.setItem('configOptions', JSON.stringify(configurations));

  return configurations;
}



// WEBPACK FOOTER //
// ./src/services/config.service.js